// extracted by mini-css-extract-plugin
export default {"mn-recommend-official-inspiration":"index_mn-recommend-official-inspiration__NJHq4"};